<template>
  <div />
</template>
<script>
  import dataLayerMixin from "../../utilities/vueMixins/dataLayerMixin/dataLayerMixin";

  export default {
    mixins: [
      dataLayerMixin
    ],
    props: {
      order: {
        type: Object,
        default() {
          return [];
        }
      },
      positions: {
        type: Array,
        default() {
          return [];
        }
      }
    },
    mounted() {
      this.trackEvent({
        event: "eec.purchase",
        ecommerce: {
          currencyCode: this.currencyCode,
          purchase: {
            actionField: {
              id: this.order.checkoutData.orderId,
              revenue: this.priceToFloat(this.order.checkoutData.totalNet),
              tax: this.priceToFloat(this.order.checkoutData.totalVat),
              shipping: this.priceToFloat(this.order.checkoutData.deliveryCostNet)
            },
            products: this.getProducts()
          }
        }
      });
    },
    methods: {
      getProducts() {
        let purchasedProducts = [];
        const _this = this;
        const categoryName = this.$t('configurator.category.description');
        this.positions.forEach(function (product) {
          const isConfigurator = product.dropShipper === 'Boxmaker';
          purchasedProducts.push({
            id: !isConfigurator ? product.itemId : '',
            itemGroupId: !isConfigurator ? product.parentId : _this.configuratorProductId,
            name: product.name,
            pricePerItemNet: _this.priceToFloat(product.price),
            categoryId: !isConfigurator ? product.categoryId : 0,
            categoryName: !isConfigurator ? product.categoryName : categoryName,
            variant: _this.sortVariant(product.variations),
            quantity: product.quantity,
            primaryImageUrl: _this.getMainFormatImage(product.imageSrc)
          });
        });
        return purchasedProducts;
      },
    }
  };

</script>
